import React, { Component } from 'react'
import Buttons from './Buttons'
import styled from 'styled-components'

export class Numpad extends Component {
  render() {
    const values = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', '⌫']
    let buttons = values.map(value => {
      return (
        <Buttons key={value} inputValue={value} />
      )
    })
    return (
      <NumpadArea>
        {buttons}
      </NumpadArea>
    )
  }
}

const NumpadArea = styled.div`
  width: 100%;
	height: 35vh;
	
	display: flex;
  flex-flow: row wrap;
  box-sizing: border-box;
`

export default Numpad